import { render, staticRenderFns } from "./GenericToggleComponent.vue?vue&type=template&id=4248ac5e"
import script from "./GenericToggleComponent.vue?vue&type=script&lang=js"
export * from "./GenericToggleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports